export default class EvidenceInfoPage {
    constructor(number=0, evidenceItem, evidenceItemOther, lat, lng, sampleCode) {
        this.number = number;
        this.evidenceItem = evidenceItem;
        this.evidenceItemOther = evidenceItemOther;
        this.lat = lat;
        this.lng = lng;
        this.sampleCode = sampleCode;
    }
}